export const disableActionsByDefault = (columnId: string) => {
  return columnId === 'periodo-descricao'
}
